import React from 'react';

import './App.css';

function Header() {
  return (
    <nav className="navbar" role="navigation" aria-label="main navigation" >
    <div className="navbar-brand">
      <p className="navbar-item">
        Weather App
      </p>
  
     
    </div>
  </nav>
  );
}

export default Header;
